module.exports = __webpack_public_path__ + "static/media/homepage_popup_advantplay.16a0109c.png";